"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FFooter = void 0;
const react_1 = __importDefault(require("react"));
const ferrum_brand_logo_png_1 = __importDefault(require("../../assets/images/ferrum-brand-logo.png"));
const FFooter = ({ footerLogo = ferrum_brand_logo_png_1.default, showLogo = true, children = undefined, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("footer", { className: "f-footer f-layout-component" },
            showLogo === true && footerLogo && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "f-logo" },
                    react_1.default.createElement("img", { src: ferrum_brand_logo_png_1.default, alt: "Logo" })))),
            react_1.default.createElement("div", { className: "f-footer-items" }, children))));
};
exports.FFooter = FFooter;
//# sourceMappingURL=Ffooter.js.map